export default {
  baseURLO: "https://api.quoteyrating.nerivon.cloud/",
  baseURL: "/api"
};
